import { Component } from '@angular/core';

@Component({
  selector: 'app-course-logout',
  templateUrl: './course-logout.component.html',
  styleUrls: ['./course-logout.component.scss']
})
export class CourseLogoutComponent {

}
